import * as React from "react";
import Box from "@mui/material/Box";
import ServicesWidgetItem from "./ServicesWidgetItem";
import { SERVICES } from "../constants/services";

/**
 * ServicesWidget component - Displays a list of available services/workflows
 * @return {JSX.Element} ServicesWidget component
 */
function ServicesWidget() {
  return (
    <Box elevation={0} sx={{ display: "flex", flexDirection: "column" }}>
      {SERVICES.map((service) => (
        <ServicesWidgetItem
          key={service.name}
          name={service.name}
          to={service.to}
          description={service.description}
        />
      ))}
    </Box>
  );
}

export default ServicesWidget;
